'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _call = require('../libs/call');

var _call2 = _interopRequireDefault(_call);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * @description :: Class for making a fetch call
 * @class Fetch
 */


var Fetch = function () {
  /**
   * @description :: Creates an instance of Fetch.
   * @param {String} url :: Url attribute
   * @memberof Fetch
   */
  function Fetch(url) {
    (0, _classCallCheck3.default)(this, Fetch);
    this.data = {
      url: '',
      method: null,
      profile: null,
      headers: [],
      query: [],
      body: null,
      credentials: null,
      mode: null
    };
    this.data.url = url;
  }
  /**
   * @description :: Setting the profile attribute
   * @param {String} profile :: Profile key
   * @return {Object} :: self
   * @memberof Fetch
   */

  /**
   * @description :: The default object attributes
   * @memberof Fetch
   */


  (0, _createClass3.default)(Fetch, [{
    key: 'profile',
    value: function profile(_profile) {
      this.data.profile = _profile;
      return this;
    }
    /**
     * @description :: Setting the query attribute
     * @param {Object} query :: Query object
     * @return {Object} :: self
     * @memberof Fetch
     */

  }, {
    key: 'query',
    value: function query(_query) {
      this.data.query = [].concat((0, _toConsumableArray3.default)(this.data.query), [_query]);
      return this;
    }
    /**
    * @description :: Setting the body attribute
    * @param {any} body :: body
    * @return {Object} :: self
    * @memberof Fetch
    */

  }, {
    key: 'body',
    value: function body(_body) {
      this.data.body = _body;
      return this;
    }
    /**
    * @description :: Setting the headers attribute
    * @param {Object} headers :: Headers object
    * @return {Object} :: self
    * @memberof Fetch
    */

  }, {
    key: 'headers',
    value: function headers(_headers) {
      this.data.headers = [].concat((0, _toConsumableArray3.default)(this.data.headers), [_headers]);
      return this;
    }
    /**
     * @description :: Setting the mode attribute
     * @param {String} mode :: Mode string
     * @return {Object} :: self
     * @memberof Fetch
     */

  }, {
    key: 'mode',
    value: function mode(_mode) {
      this.data.mode = _mode;
      return this;
    }
    /**
     * @description :: Setting the credentials attribute
     * @param {String} credentials :: Credentials string
     * @return {Object} :: self
     * @memberof Fetch
     */

  }, {
    key: 'credentials',
    value: function credentials(_credentials) {
      this.data.credentials = _credentials;
      return this;
    }
    /**
     * @description :: Making a GET call
     * @return {Promise} :: Fetch promise
     * @memberof Fetch
     */

  }, {
    key: 'get',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.data.method = 'GET';
                _context.next = 3;
                return (0, _call2.default)(this.data);

              case 3:
                return _context.abrupt('return', _context.sent);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function get() {
        return _ref.apply(this, arguments);
      }

      return get;
    }()
    /**
     * @description :: Making a POST call
     * @return {Promise} :: Fetch promise
     * @memberof Fetch
     */

  }, {
    key: 'post',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.data.method = 'POST';
                _context2.next = 3;
                return (0, _call2.default)(this.data);

              case 3:
                return _context2.abrupt('return', _context2.sent);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function post() {
        return _ref2.apply(this, arguments);
      }

      return post;
    }()
    /**
     * @description :: Making a PATCH call
     * @return {Promise} :: Fetch promise
     * @memberof Fetch
     */

  }, {
    key: 'patch',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.data.method = 'PATCH';
                _context3.next = 3;
                return (0, _call2.default)(this.data);

              case 3:
                return _context3.abrupt('return', _context3.sent);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function patch() {
        return _ref3.apply(this, arguments);
      }

      return patch;
    }()
    /**
     * @description :: Making a PUT call
     * @return {Promise} :: Fetch promise
     * @memberof Fetch
     */

  }, {
    key: 'put',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.data.method = 'PUT';
                _context4.next = 3;
                return (0, _call2.default)(this.data);

              case 3:
                return _context4.abrupt('return', _context4.sent);

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function put() {
        return _ref4.apply(this, arguments);
      }

      return put;
    }()
    /**
     * @description :: Making a DELETE call
     * @return {Promise} :: Fetch promise
     * @memberof Fetch
     */

  }, {
    key: 'delete',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.data.method = 'DELETE';
                _context5.next = 3;
                return (0, _call2.default)(this.data);

              case 3:
                return _context5.abrupt('return', _context5.sent);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete() {
        return _ref5.apply(this, arguments);
      }

      return _delete;
    }()
    /**
     * @description :: Making a HEAD call
     * @return {Promise} :: Fetch promise
     * @memberof Fetch
     */

  }, {
    key: 'head',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.data.method = 'HEAD';
                _context6.next = 3;
                return (0, _call2.default)(this.data);

              case 3:
                return _context6.abrupt('return', _context6.sent);

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function head() {
        return _ref6.apply(this, arguments);
      }

      return head;
    }()
    /**
     * @description :: Making an OPTIONS call
     * @return {Promise} :: Fetch promise
     * @memberof Fetch
     */

  }, {
    key: 'options',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.data.method = 'OPTIONS';
                _context7.next = 3;
                return (0, _call2.default)(this.data);

              case 3:
                return _context7.abrupt('return', _context7.sent);

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function options() {
        return _ref7.apply(this, arguments);
      }

      return options;
    }()
  }]);
  return Fetch;
}(); // Libs


exports.default = Fetch;